import { QualityLowIcon } from './QualityLowIcon';

/**
 * author: Michael Irigoyen
 * id 51E44ABD-8132-4758-905E-4F46784ED768
 * name quality-low
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/quality-low.svg
 * tags
 */
export const LqIcon = QualityLowIcon;
export default LqIcon